import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { GoogleLogin } from '@react-oauth/google';
import { apiFetch } from '../utils/api';
import '../styles/auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();

      // If backend indicates verification required, redirect to verify page
      if (data && data.requiresVerification) {
        alert(data.message || 'Please verify your email. A new OTP has been sent.');
        navigate(`/verify-otp?email=${encodeURIComponent(data.email)}`);
        return;
      }

      if (res.ok) {
        login(data);
        navigate('/');
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/auth/google', {
        method: 'POST',
        body: JSON.stringify({ credential: credentialResponse.credential })
      });
      const data = await res.json();

      if (res.ok && data.success) {
        login({
          _id: data.user._id,
          name: data.user.name,
          email: data.user.email,
          role: data.user.role,
          avatar: data.user.avatar
        });
        navigate('/');
      } else {
        alert(data.message || 'Google login failed');
      }
    } catch (error) {
      console.error('Google login error:', error);
      alert('An error occurred during Google Login.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = () => {
    alert('Google sign-in failed. Please try again.');
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Login</h2>
        <div className={`google-btn-container ${loading ? 'disabled' : ''}`}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme="filled_black"
            text="continue_with"
            shape="rectangular"
            width="100%"
          />
        </div>
                <div className="auth-divider">
          <span className="line"></span>
          <span className="text">OR</span>
          <span className="line"></span>
        </div>

        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={loading} />
        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Please wait...' : 'Login'}
        </button>
        <p>Forgot your password? <Link to="/forgot-password">Reset it</Link></p>
        <p>Don't have an account? <Link to="/register">Register</Link></p>  
      </form>
    </div>
  );
};

export default Login;
